import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { HeroImage } from '../../components/HeroImage';
import { HeroTitle } from '../../components/HeroTitle';

import './POIHeroSection.scss';

export interface POIHeroSectionProps {
    imageSource: string;
    pointOfInterestName: string;
    htmlAttribution?: string;
}

export const POIHeroSection: React.FunctionComponent<POIHeroSectionProps> = (
    props,
) => {
    const GOOGLE_PHOTO_HTML_ATTRIBUTIONS = props.htmlAttribution;

    return (
        <>
            <header id="poi-hero-section-header">
                {props.pointOfInterestName ? (
                    <HeroTitle title={props.pointOfInterestName} />
                ) : null}

                {props.imageSource ? (
                    <HeroImage
                        htmlAttribution={GOOGLE_PHOTO_HTML_ATTRIBUTIONS}
                        imageSource={props.imageSource}
                        altText={gettext(
                            'Events and things to do near %(pointOfInterest)s',
                            {
                                pointOfInterest: props.pointOfInterestName,
                            },
                        ).toString()}
                    />
                ) : null}
            </header>
        </>
    );
};
